module.exports = __webpack_public_path__ + "static/media/product10.10e8b53b.jpg";